<template>
    <div>
      <!-- <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive> -->
      <router-view/>
    </div>
</template>

<script>
  export default {
    name: 'game'
  }
</script>

<style scoped>

</style>
